const initTryNow = () => {
	try {
		const tryNowButton = document.querySelector('trynow-cta-button')
		const gatedToggle = document.querySelector('gated-flow-toggle')
		
		if (!tryNowButton || !gatedToggle) return

		const parentElement = tryNowButton.parentElement
		parentElement.classList.add('trynow-container')
	
		const formContainer = document.querySelector('.product__info-wrapper form[action="/cart/add"]')
		const priceEl = document.querySelector('.product__info-wrapper .price')
	
		const nextSibling = formContainer.querySelector('.product-form__buttons').nextSibling
		formContainer.insertBefore(parentElement, nextSibling)

		const tryNowLearnMore = document.querySelector('#tn-cta-info-icon')
		if (tryNowLearnMore) {
			const span = document.createElement('span')
			span.textContent = 'How Try Before You Buy Works'
			tryNowLearnMore.prepend(span) 
		}

		// const priceRegularEl = document.querySelector('.product__info-wrapper .price-item--regular')
		// const priceCouponEl = document.querySelector('.product__info-wrapper .price-coupon-discounted')

		// const getPriceText = () => {
		// 	if (priceCouponEl) {
		// 		return priceCouponEl.querySelector('strong').textContent
		// 	}
		// 	else {
		// 		return priceRegularEl.textContent
		// 	}
		// }

		const tryNowTagline = document.querySelector('.tn-gate-toggle-tagline')
		const TAGLINES = {
			CHECKED: 'No thanks, show other buying options',
			UNCHECKED: 'Unsure? Try for 10 Days Before You Buy'
		}
		const onUpdateTagline = (checked) => {
			tryNowTagline.textContent = checked
				? TAGLINES.CHECKED
				: TAGLINES.UNCHECKED
		}

		const toggle = parentElement.querySelector('gated-flow-toggle input[type="checkbox"]')
		const onToggle = (checked) => {
			formContainer.classList.toggle('trynow-active', checked)
			// priceEl.classList.toggle('is-hidden', checked)
			onUpdateTagline(checked)
			// Is not subscription
			const inputIsSubscription = formContainer.querySelector('.is-subscription');
			if (inputIsSubscription) {
				inputIsSubscription.value = inputIsSubscription.value === 'true' ? 'false' : 'true';
			}
		}
	
		toggle.addEventListener('change', (event) => onToggle(event.target.checked))

		if (tryNowTagline) {
			// tryNowButton.appendChild(gatedToggle.parentNode)
			onUpdateTagline(toggle.checked)
		}

		const observeDisplayChanges = (element) => {
			const observer = new MutationObserver(mutationsList => {
				for (const mutation of mutationsList) {
					if (mutation.attributeName === 'style') {
						const displayValue = window.getComputedStyle(element).display
						if (displayValue !== 'none') {
							onToggle(toggle.checked)
						}
					}
				}
			})
			observer.observe(element, { attributes: true, attributeFilter: ['style'] })
		}

		if (window.getComputedStyle(gatedToggle).display !== 'none') {
			onToggle(toggle.checked)
		}

		observeDisplayChanges(document.querySelector('gated-flow-toggle'))
	} catch (error) {
		console.error('initTryNow error: ', error)
	}
}

initTryNow()